export const SALES_PERFORMANCE_COLUMNS = [
  {
    Header: "Customer",
    id: "customer",
    accessor: "customer",
    minWidth: 150
  },
  {
    Header: "Project",
    id: "name",
    accessor: "name",
    minWidth: 150
  },
  {
    Header: "Status",
    id: "projectStatus",
    accessor: "projectStatus"
  },
  {
    Header: "Category",
    id: "category",
    accessor: "category"
  },
  {
    Header: "Call Type",
    id: "callType",
    accessor: "callType"
  },
  {
    Header: "Billing Rate",
    id: "rate",
    accessor: "rate",
    Cell: ({ value }) => `$ ${value}`
  },
  {
    Header: "Billable Hours",
    id: "billableHours",
    accessor: "billableHours",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Total Billed",
    id: "totalBilled",
    accessor: "totalBilled",
    Cell: ({ value }) => `$ ${value}`
  }
];
